import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconCalendar = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <rect width={18} height={17} x={3} y={4} stroke="currentColor" strokeWidth={2} rx={2} />
    <path
      fill="currentColor"
      d="M8.25 2a1.25 1.25 0 1 0-2.5 0zm-2.5 5v1.25h2.5V7zm0-5v5h2.5V2zM18.25 2a1.25 1.25 0 1 0-2.5 0zm-2.5 5v1.25h2.5V7zm0-5v5h2.5V2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 11H3"
    />
    <path fill="currentColor" d="M8.2 16.2V14H6v2.2zM13.2 16.2V14H11v2.2zM18.2 16.2V14H16v2.2z" />
  </NcIcon>
);
export { NcIconCalendar };
